import React, { useState } from "react";
import {
  Button,
  Grid,
  TextField,
  Table,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Collapse,
  Tooltip,
} from "@material-ui/core";
import { connect } from "react-redux";
import {
  updateForm,
  testUserData,
  testCalculatorData,
  setAge1,
  setAge2,
  setBirthday1,
  setBirthday2,
  setTotalIncome,
  setNon401IraIncome,
  generateBudget,
  generateWages,
  generateSS,
  generatePrivatePension,
  generatePublicPension,
  setInvestmentIncome,
  generateShortfall,
  generateYears,
  setMarriedIncome,
  calculateNeeded,
} from "../state/calculator";
import CreateIcon from "@material-ui/icons/Create";
import { bindActionCreators } from "redux";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import LoaderButton from "./LoaderButton";
import Trivia from "./Trivia";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Calculator(props) {
  const [showTriviaModal, setTriviaModal] = useState(false);
  const [collapseInvestments, setCollapseInvestments] = useState(false);
  const [collapseBenefits, setCollapseBenefits] = useState(false);
  const [collapseIncome, setCollapseIncome] = useState(false);

  const {
    ageWagesStopS2,
    retireAgeS2,
    wagesS2,
    socialSecurityS2,
    pvtPensionS2,
    pvtPensionAgeS2,
    pubPensionS2,
    pubPensionAgeS2,
    k401S2,
    k401AgeS2,
  } = props.redux;

  const {
    targetTaxableBudgetS1,
    birthdayS1,
    birthdayS2,
    ageS1,
    ageWagesStopS1,
    retireYearS1,
    retireAgeS1,
    wagesS1,
    socialSecurityS1,
    pvtPensionS1,
    pvtPensionAgeS1,
    pubPensionS1,
    pubPensionAgeS1,
    k401S1,
    k401AgeS1,
    iraS1,
    years,

    budgetArray,
    ageArray,
    wageArray,
    ssArray,
    pvtArray,
    pubArray,
    non401IRAArray,
    totalIncomeArray,
    investmentIncomeArray,
    incomeNeededArray,
    annuityIncomeArray,
    ageGroupArrayS1,
    ageGroupArrayS2,
    marriedAgeArray,
    marriedWageArray,
    marriedSsArray,
    marriedPvtArray,
    marriedPubArray,
    marriedInvestmentIncomeArray,
    actualInvestmentArray,
    marriedActualInvestmentArray,
    marriedIncomeNeededArray,
    marriedAnnuityIncomeArray,
  } = props.redux;

  const [value, setValue] = React.useState(0);

  const handleSubmitIncome = () => {
    let birthYear = birthdayS1.split("-");
    let age = 2020 - birthYear[1];
    // let's come back to this later
    let ira59Year = 2020 - (age - 59);
    let retireYear = parseInt(birthYear[1], 10) + parseInt(retireAgeS1, 10);

    let birthYear2 = birthdayS2.split("-");
    let age2 = 2020 - birthYear2[1];
    // let's come back to this later
    let ira59Year2 = 2020 - (age2 - 59);
    let retireYear2 = parseInt(birthYear2[1], 10) + parseInt(retireAgeS2, 10);

    // @TODO: make sure that a school district is included as often as possible
    // @TODO: home insurance in chrome extension
    // @TODO: make update income and 4SP's one button, with loading screen
    // @TODO: Test in California, New York, Pennsylvania (school district dependent);
    // @TODO: Add implicit value of 0, if a particular form is blank (specifically private and public pension)
    // @TODO: Show Reported Household IRA/S1 % in the database, double check that it is what is being sent to the db (not the full amount if excess/minimized draw.)

    let TaxFile;
    let NumSub;
    let HealthIns;
    let ActiveInvArray;
    let tempS1Inv = [];
    let tempS2Inv = [];
    let tempCalcInv;

    marriedActualInvestmentArray.map((inv, i) => {
      tempCalcInv = inv / 2;
      tempS1Inv.push(tempCalcInv);
      tempS2Inv.push(tempCalcInv);
    });

    // @TODO needs to be S or P, depending on the form value.
    if (props.redux.both === true) {
      TaxFile = "MJ";
      NumSub = 2;
      ActiveInvArray = tempS1Inv;
    } else {
      TaxFile = "S";
      NumSub = 1;
      ActiveInvArray = actualInvestmentArray;
    }

    if (props.redux.healthInsurance === true) {
      HealthIns = "y";
    } else {
      HealthIns = "n";
    }

    let body = {
      user_token: props.redux.id,
      Subject: "S1",
      NumSub: NumSub,
      TaxFile: TaxFile,
      // TaxFile: "P",
      TargetTaxableBudget: parseInt(budgetArray[0], 10),
      BirthYear: parseInt(birthYear[1], 10),
      Age: age,
      IRA59: ira59Year,
      RetireYear: retireYear,
      HealthIns: HealthIns,
      // double check below
      PlannedIRAKDistribute: parseInt(k401S1, 10),
      Year1: years[0],
      Year2: years[1],
      Year3: years[2],
      Year4: years[3],
      Year5: years[4],
      Year6: years[5],
      Year7: years[6],
      Year8: years[7],
      Year9: years[8],
      Year10: years[9],
      AgeYear1: parseInt(ageArray[0], 10),
      AgeYear2: parseInt(ageArray[1], 10),
      AgeYear3: parseInt(ageArray[2], 10),
      AgeYear4: parseInt(ageArray[3], 10),
      AgeYear5: parseInt(ageArray[4], 10),
      AgeYear6: parseInt(ageArray[5], 10),
      AgeYear7: parseInt(ageArray[6], 10),
      AgeYear8: parseInt(ageArray[7], 10),
      AgeYear9: parseInt(ageArray[8], 10),
      AgeYear10: parseInt(ageArray[9], 10),
      WagesY1: parseInt(wageArray[0], 10),
      WagesY2: parseInt(wageArray[1], 10),
      WagesY3: parseInt(wageArray[2], 10),
      WagesY4: parseInt(wageArray[3], 10),
      WagesY5: parseInt(wageArray[4], 10),
      WagesY6: parseInt(wageArray[5], 10),
      WagesY7: parseInt(wageArray[6], 10),
      WagesY8: parseInt(wageArray[7], 10),
      WagesY9: parseInt(wageArray[8], 10),
      WagesY10: parseInt(wageArray[9], 10),
      SSY1: parseInt(ssArray[0], 10),
      SSY2: parseInt(ssArray[1], 10),
      SSY3: parseInt(ssArray[2], 10),
      SSY4: parseInt(ssArray[3], 10),
      SSY5: parseInt(ssArray[4], 10),
      SSY6: parseInt(ssArray[5], 10),
      SSY7: parseInt(ssArray[6], 10),
      SSY8: parseInt(ssArray[7], 10),
      SSY9: parseInt(ssArray[8], 10),
      SSY10: parseInt(ssArray[9], 10),
      PvtPenY1: parseInt(pvtArray[0], 10),
      PvtPenY2: parseInt(pvtArray[1], 10),
      PvtPenY3: parseInt(pvtArray[2], 10),
      PvtPenY4: parseInt(pvtArray[3], 10),
      PvtPenY5: parseInt(pvtArray[4], 10),
      PvtPenY6: parseInt(pvtArray[5], 10),
      PvtPenY7: parseInt(pvtArray[6], 10),
      PvtPenY8: parseInt(pvtArray[7], 10),
      PvtPenY9: parseInt(pvtArray[8], 10),
      PvtPenY10: parseInt(pvtArray[9], 10),
      PubPenY1: parseInt(pubArray[0], 10),
      PubPenY2: parseInt(pubArray[1], 10),
      PubPenY3: parseInt(pubArray[2], 10),
      PubPenY4: parseInt(pubArray[3], 10),
      PubPenY5: parseInt(pubArray[4], 10),
      PubPenY6: parseInt(pubArray[5], 10),
      PubPenY7: parseInt(pubArray[6], 10),
      PubPenY8: parseInt(pubArray[7], 10),
      PubPenY9: parseInt(pubArray[8], 10),
      PubPenY10: parseInt(pubArray[9], 10),
      IRAKY1: parseInt(ActiveInvArray[0], 10),
      IRAKY2: parseInt(ActiveInvArray[1], 10),
      IRAKY3: parseInt(ActiveInvArray[2], 10),
      IRAKY4: parseInt(ActiveInvArray[3], 10),
      IRAKY5: parseInt(ActiveInvArray[4], 10),
      IRAKY6: parseInt(ActiveInvArray[5], 10),
      IRAKY7: parseInt(ActiveInvArray[6], 10),
      IRAKY8: parseInt(ActiveInvArray[7], 10),
      IRAKY9: parseInt(ActiveInvArray[8], 10),
      IRAKY10: parseInt(ActiveInvArray[9], 10),
      AgeGroup1: parseInt(ageGroupArrayS1[0], 10),
      AgeGroup2: parseInt(ageGroupArrayS1[1], 10),
      AgeGroup3: parseInt(ageGroupArrayS1[2], 10),
      AgeGroup4: parseInt(ageGroupArrayS1[3], 10),
      AgeGroup5: parseInt(ageGroupArrayS1[4], 10),
      AgeGroup6: parseInt(ageGroupArrayS1[5], 10),
      AgeGroup7: parseInt(ageGroupArrayS1[6], 10),
      AgeGroup8: parseInt(ageGroupArrayS1[7], 10),
      AgeGroup9: parseInt(ageGroupArrayS1[8], 10),
      AgeGroup10: parseInt(ageGroupArrayS1[9], 10),
    };

    let body2 = {
      user_token: props.redux.id,
      Subject: "S2",
      NumSub: NumSub,
      TaxFile: TaxFile,
      TargetTaxableBudget: parseInt(budgetArray[0], 10),
      BirthYear: parseInt(birthYear2[1], 10),
      Age: age2,
      IRA59: ira59Year2,
      RetireYear: retireYear2,
      HealthIns: HealthIns,
      // double check below
      PlannedIRAKDistribute: parseInt(k401S1, 10),
      Year1: years[0],
      Year2: years[1],
      Year3: years[2],
      Year4: years[3],
      Year5: years[4],
      Year6: years[5],
      Year7: years[6],
      Year8: years[7],
      Year9: years[8],
      Year10: years[9],
      AgeYear1: parseInt(marriedAgeArray[0], 10),
      AgeYear2: parseInt(marriedAgeArray[1], 10),
      AgeYear3: parseInt(marriedAgeArray[2], 10),
      AgeYear4: parseInt(marriedAgeArray[3], 10),
      AgeYear5: parseInt(marriedAgeArray[4], 10),
      AgeYear6: parseInt(marriedAgeArray[5], 10),
      AgeYear7: parseInt(marriedAgeArray[6], 10),
      AgeYear8: parseInt(marriedAgeArray[7], 10),
      AgeYear9: parseInt(marriedAgeArray[8], 10),
      AgeYear10: parseInt(marriedAgeArray[9], 10),
      WagesY1: parseInt(marriedWageArray[0], 10),
      WagesY2: parseInt(marriedWageArray[1], 10),
      WagesY3: parseInt(marriedWageArray[2], 10),
      WagesY4: parseInt(marriedWageArray[3], 10),
      WagesY5: parseInt(marriedWageArray[4], 10),
      WagesY6: parseInt(marriedWageArray[5], 10),
      WagesY7: parseInt(marriedWageArray[6], 10),
      WagesY8: parseInt(marriedWageArray[7], 10),
      WagesY9: parseInt(marriedWageArray[8], 10),
      WagesY10: parseInt(marriedWageArray[9], 10),
      SSY1: parseInt(marriedSsArray[0], 10),
      SSY2: parseInt(marriedSsArray[1], 10),
      SSY3: parseInt(marriedSsArray[2], 10),
      SSY4: parseInt(marriedSsArray[3], 10),
      SSY5: parseInt(marriedSsArray[4], 10),
      SSY6: parseInt(marriedSsArray[5], 10),
      SSY7: parseInt(marriedSsArray[6], 10),
      SSY8: parseInt(marriedSsArray[7], 10),
      SSY9: parseInt(marriedSsArray[8], 10),
      SSY10: parseInt(marriedSsArray[9], 10),
      PvtPenY1: parseInt(marriedPvtArray[0], 10),
      PvtPenY2: parseInt(marriedPvtArray[1], 10),
      PvtPenY3: parseInt(marriedPvtArray[2], 10),
      PvtPenY4: parseInt(marriedPvtArray[3], 10),
      PvtPenY5: parseInt(marriedPvtArray[4], 10),
      PvtPenY6: parseInt(marriedPvtArray[5], 10),
      PvtPenY7: parseInt(marriedPvtArray[6], 10),
      PvtPenY8: parseInt(marriedPvtArray[7], 10),
      PvtPenY9: parseInt(marriedPvtArray[8], 10),
      PvtPenY10: parseInt(marriedPvtArray[9], 10),
      PubPenY1: parseInt(marriedPubArray[0], 10),
      PubPenY2: parseInt(marriedPubArray[1], 10),
      PubPenY3: parseInt(marriedPubArray[2], 10),
      PubPenY4: parseInt(marriedPubArray[3], 10),
      PubPenY5: parseInt(marriedPubArray[4], 10),
      PubPenY6: parseInt(marriedPubArray[5], 10),
      PubPenY7: parseInt(marriedPubArray[6], 10),
      PubPenY8: parseInt(marriedPubArray[7], 10),
      PubPenY9: parseInt(marriedPubArray[8], 10),
      PubPenY10: parseInt(marriedPubArray[9], 10),
      IRAKY1: parseInt(tempS2Inv[0], 10),
      IRAKY2: parseInt(tempS2Inv[1], 10),
      IRAKY3: parseInt(tempS2Inv[2], 10),
      IRAKY4: parseInt(tempS2Inv[3], 10),
      IRAKY5: parseInt(tempS2Inv[4], 10),
      IRAKY6: parseInt(tempS2Inv[5], 10),
      IRAKY7: parseInt(tempS2Inv[6], 10),
      IRAKY8: parseInt(tempS2Inv[7], 10),
      IRAKY9: parseInt(tempS2Inv[8], 10),
      IRAKY10: parseInt(tempS2Inv[9], 10),
      AgeGroup1: parseInt(ageGroupArrayS2[0], 10),
      AgeGroup2: parseInt(ageGroupArrayS2[1], 10),
      AgeGroup3: parseInt(ageGroupArrayS2[2], 10),
      AgeGroup4: parseInt(ageGroupArrayS2[3], 10),
      AgeGroup5: parseInt(ageGroupArrayS2[4], 10),
      AgeGroup6: parseInt(ageGroupArrayS2[5], 10),
      AgeGroup7: parseInt(ageGroupArrayS2[6], 10),
      AgeGroup8: parseInt(ageGroupArrayS2[7], 10),
      AgeGroup9: parseInt(ageGroupArrayS2[8], 10),
      AgeGroup10: parseInt(ageGroupArrayS2[9], 10),
    };
    try {
      console.log(body);
      console.log(body2);
      fetch(`http://${process.env.REACT_APP_STAGE}/income/save`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
      })
        .then((response) => response.text())
        .then((data) => {
          // let parsedData = JSON.parse(data);
          console.log("USER Income Post :", data);
          return data;
        });
      if (props.redux.both === true) {
        fetch(`http://${process.env.REACT_APP_STAGE}/income/save`, {
          method: "POST",
          body: JSON.stringify(body2),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
          .then((response) => response.text())
          .then((data) => {
            // let parsedData = JSON.parse(data);
            console.log("USER Income Post :", data);
            return data;
          });
      }
    } catch (e) {
      console.log(e);
    }
  };

  // console.log("S1 Investment: ", actualInvestmentArray);
  // console.log("S2 Investment: ", marriedActualInvestmentArray);

  const submitCalculationSP = () => {
    let body = {
      user_token: props.redux.id,
      prop_id: 0,
    };
    try {
      fetch(`http://${process.env.REACT_APP_STAGE}/income/fetch`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
      })
        .then((response) => response.text())
        .then((data) => {
          // let parsedData = JSON.parse(data);
          console.log("USER Income Post :", data);
          return data;
        });
    } catch (e) {
      console.log(e);
    }
  };

  const deleteIncomeData = () => {
    let body = {
      user_token: props.redux.id,
    };
    try {
      fetch(`http://${process.env.REACT_APP_STAGE}/income/delete/income`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
      })
        .then((response) => response.text())
        .then((data) => {
          // let parsedData = JSON.parse(data);
          console.log("USER Income Post :", data);
          return data;
        });
    } catch (e) {
      console.log(e);
    }
  };

  const requestTenYearView = () => {
    let body = {
      user_token: props.redux.id,
      prop_id: props.redux.properties[1].Prop_id,
    };
    try {
      fetch(`http://${process.env.REACT_APP_STAGE}/returns/property`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
      })
        .then((response) => response.text())
        .then((data) => {
          let parsedData = JSON.parse(data);
          let newStr = "";
          for (let i = 0; i < parsedData.length; i++) {
            newStr =
              newStr +
              parsedData[i]["JSON_F52E2B61-18A1-11d1-B105-00805F49916B"];
          }
          let parsedJSON = JSON.parse(newStr);
          console.log(parsedJSON);
          return parsedJSON;
        });
    } catch (e) {
      console.log(e);
    }
  };

  const requestTenYearBaseView = () => {
    let body = {
      user_token: props.redux.id,
    };
    try {
      fetch(`http://${process.env.REACT_APP_STAGE}/returns/base`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
      })
        .then((response) => response.text())
        .then((data) => {
          let parsedData = JSON.parse(data);
          let newStr = "";
          for (let i = 0; i < parsedData.length; i++) {
            newStr =
              newStr +
              parsedData[i]["JSON_F52E2B61-18A1-11d1-B105-00805F49916B"];
          }
          let parsedJSON = JSON.parse(newStr);
          console.log(parsedJSON);
          return parsedJSON;
        });
    } catch (e) {
      console.log(e);
    }
  };

  const handleChange = (event) => {
    const value = event.target.value;
    switch (event.target.name) {
      case "UPDATE_FORM":
        let obj = { id: event.target.id, value: event.target.value };
        // we need to add in a check when we submit the data to the database that retireAgeS1 value should be >= 62
        if (event.target.id === "retireAgeS1") {
          if (event.target.value == 6 || event.target.value == 7) {
            props.updateForm(obj);
          } else if (event.target.value < 62) {
            alert("Social Security must be at least 62 years old.");
          } else {
            props.updateForm(obj);
          }
        } else {
          props.updateForm(obj);
        }
        break;
      default:
        return value;
    }
  };

  const formStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "start",
    paddingBottom: 10,
  };

  return (
    <div className="responsive-calculator" id="calculator">
      <Grid>
        {props.redux.both ? (
          <React.Fragment>
            <Button onClick={() => setValue(0)}>S1</Button>
            <Button onClick={() => setValue(1)}>S2</Button>
          </React.Fragment>
        ) : null}

        {value === 0 ? (
          <React.Fragment>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Button
                onClick={() => setCollapseIncome(!collapseIncome)}
                style={{ alignSelf: "start" }}
              >
                Income
                <CreateIcon />
              </Button>

              <Collapse in={collapseIncome} timeout="auto" unmountOnExit>
                <React.Fragment>
                  <div style={formStyle}>
                    <Tooltip title="What wages are you earning for part-time work during retirement to make up any financial deficits? Estimate an annual amount.">
                      <span className="userInputLabel">
                        Current Non-Retirement Income
                      </span>
                    </Tooltip>
                    <TextField
                      id="wagesS1"
                      className="userInputBox"
                      type="text"
                      onChange={handleChange}
                      name="UPDATE_FORM"
                      value={wagesS1}
                    />
                  </div>
                  {!props.redux.justWagesS1 ? (
                    <div style={formStyle}>
                      <Tooltip title="This is the year that you stop working, and stop receiving salary.">
                        <span className="userInputLabel">
                          Target Retirement Year
                        </span>
                      </Tooltip>
                      <TextField
                        id="ageWagesStopS1"
                        className="userInputBox"
                        type="text"
                        onChange={handleChange}
                        name="UPDATE_FORM"
                        value={ageWagesStopS1}
                      />
                    </div>
                  ) : null}
                </React.Fragment>
              </Collapse>

              <Button
                onClick={() => setCollapseBenefits(!collapseBenefits)}
                style={{ alignSelf: "start" }}
              >
                Retirement
                <CreateIcon />
              </Button>

              <Collapse in={collapseBenefits} timeout="auto" unmountOnExit>
                <div style={formStyle}>
                  <span className="userInputLabel">Social Security</span>
                  <TextField
                    id="socialSecurityS1"
                    className="userInputBox"
                    type="text"
                    onChange={handleChange}
                    name="UPDATE_FORM"
                    value={socialSecurityS1}
                  />
                </div>
                <div style={formStyle}>
                  <span className="userInputLabel">SS Draw Age</span>
                  <TextField
                    id="retireAgeS1"
                    className="userInputBox"
                    type="text"
                    onChange={handleChange}
                    name="UPDATE_FORM"
                    value={retireAgeS1}
                  />
                </div>
                <div style={formStyle}>
                  <span className="userInputLabel">Private Pension</span>
                  <TextField
                    id="pvtPensionS1"
                    className="userInputBox"
                    type="text"
                    onChange={handleChange}
                    name="UPDATE_FORM"
                    value={pvtPensionS1}
                  />
                </div>
                <div style={formStyle}>
                  <span className="userInputLabel">Private Draw Age</span>
                  <TextField
                    id="pvtPensionAgeS1"
                    className="userInputBox"
                    type="text"
                    onChange={handleChange}
                    name="UPDATE_FORM"
                    value={pvtPensionAgeS1}
                  />
                </div>
                <div style={formStyle}>
                  <span className="userInputLabel">Public Pension</span>
                  <TextField
                    id="pubPensionS1"
                    className="userInputBox"
                    type="text"
                    onChange={handleChange}
                    name="UPDATE_FORM"
                    value={pubPensionS1}
                  />
                </div>
                <div style={formStyle}>
                  <span className="userInputLabel">Public Draw Age</span>
                  <TextField
                    id="pubPensionAgeS1"
                    className="userInputBox"
                    type="text"
                    onChange={handleChange}
                    name="UPDATE_FORM"
                    value={pubPensionAgeS1}
                  />
                </div>
              </Collapse>

              <Button
                onClick={() => setCollapseInvestments(!collapseInvestments)}
                style={{ alignSelf: "start" }}
              >
                Investments
                <CreateIcon />
              </Button>
              <Collapse in={collapseInvestments} timeout="auto" unmountOnExit>
                <div style={formStyle}>
                  <span className="userInputLabel">IRA/401k Total</span>
                  <TextField
                    id="k401S1"
                    className="userInputBox"
                    type="text"
                    onChange={handleChange}
                    name="UPDATE_FORM"
                    value={k401S1}
                  />
                </div>
                <div style={formStyle}>
                  <span className="userInputLabel">IRA/401k Age</span>
                  <TextField
                    id="k401AgeS1"
                    className="userInputBox"
                    type="text"
                    onChange={handleChange}
                    name="UPDATE_FORM"
                    value={k401AgeS1}
                  />
                </div>
              </Collapse>
            </div>
          </React.Fragment>
        ) : null}

        {/* Subject 2 Forms Below */}
        {value === 1 ? (
          <div
            style={{ display: "flex", flexDirection: "column" }}
            id="s2input"
          >
            <div style={formStyle}>
              <Tooltip title="What wages are you earning for part-time work during retirement to make up any financial deficits? Estimate an annual amount.">
                <span className="userInputLabel">
                  Current Non-Retirement Income
                </span>
              </Tooltip>
              <TextField
                id="wagesS2"
                className="userInputBox"
                type="text"
                onChange={handleChange}
                name="UPDATE_FORM"
                value={wagesS2}
              />
            </div>
            {!props.redux.justWagesS2 ? (
              <div style={formStyle}>
                <span className="userInputLabel">Target Retirement Year</span>
                <TextField
                  id="ageWagesStopS2"
                  className="userInputBox"
                  type="text"
                  onChange={handleChange}
                  name="UPDATE_FORM"
                  value={ageWagesStopS2}
                />
              </div>
            ) : null}
            <Button
              onClick={() => setCollapseBenefits(!collapseBenefits)}
              style={{ alignSelf: "start" }}
            >
              Retirement
              <CreateIcon />
            </Button>

            <Collapse in={collapseBenefits} timeout="auto" unmountOnExit>
              <div style={formStyle}>
                <span className="userInputLabel">Social Security</span>
                <TextField
                  id="socialSecurityS2"
                  className="userInputBox"
                  type="text"
                  onChange={handleChange}
                  name="UPDATE_FORM"
                  value={socialSecurityS2}
                />
              </div>
              <div style={formStyle}>
                <span className="userInputLabel">SS Draw Age</span>
                <TextField
                  id="retireAgeS2"
                  className="userInputBox"
                  type="text"
                  onChange={handleChange}
                  name="UPDATE_FORM"
                  value={retireAgeS2}
                />
              </div>
              <div style={formStyle}>
                <span className="userInputLabel">Private Pension</span>
                <TextField
                  id="pvtPensionS2"
                  className="userInputBox"
                  type="text"
                  onChange={handleChange}
                  name="UPDATE_FORM"
                  value={pvtPensionS2}
                />
              </div>
              <div style={formStyle}>
                <span className="userInputLabel">Private Draw Age</span>
                <TextField
                  id="pvtPensionAgeS2"
                  className="userInputBox"
                  type="text"
                  onChange={handleChange}
                  name="UPDATE_FORM"
                  value={pvtPensionAgeS2}
                />
              </div>
              <div style={formStyle}>
                <span className="userInputLabel">Public Pension</span>
                <TextField
                  id="pubPensionS2"
                  className="userInputBox"
                  type="text"
                  onChange={handleChange}
                  name="UPDATE_FORM"
                  value={pubPensionS2}
                />
              </div>
              <div style={formStyle}>
                <span className="userInputLabel">Public Draw Age</span>
                <TextField
                  id="pubPensionAgeS2"
                  className="userInputBox"
                  type="text"
                  onChange={handleChange}
                  name="UPDATE_FORM"
                  value={pubPensionAgeS2}
                />
              </div>
            </Collapse>

            <Button
              onClick={() => setCollapseInvestments(!collapseInvestments)}
              style={{ alignSelf: "start" }}
            >
              Investments
              <CreateIcon />
            </Button>
            <Collapse in={collapseInvestments} timeout="auto" unmountOnExit>
              <div style={formStyle}>
                <span className="userInputLabel">IRA/401k Total</span>
                <TextField
                  id="k401S2"
                  className="userInputBox"
                  type="text"
                  onChange={handleChange}
                  name="UPDATE_FORM"
                  value={k401S2}
                />
              </div>
              <div style={formStyle}>
                <span className="userInputLabel">IRA/401k Age</span>
                <TextField
                  id="k401AgeS2"
                  className="userInputBox"
                  type="text"
                  onChange={handleChange}
                  name="UPDATE_FORM"
                  value={k401AgeS2}
                />
              </div>
            </Collapse>
          </div>
        ) : null}
        <br />
        <Button onClick={() => handleSubmitIncome()}>Submit Income</Button>
        <Button onClick={() => submitCalculationSP()}>Submit SP</Button>
        <Button onClick={() => requestTenYearView()}>Request 10 Yr</Button>
        <Button onClick={() => requestTenYearBaseView()}>
          Request 10Yr for Base
        </Button>
        <Button onClick={() => deleteIncomeData()}>Delete</Button>
        <LoaderButton onClick={() => setTriviaModal(true)}>
          Trivia!
        </LoaderButton>
      </Grid>
      <Grid className="calculatorOutput" container item>
        <TableContainer component={Paper}>
          <Table
            className="subjectAges"
            size="small"
            aria-label="a dense table"
          >
            <TableHead style={{ backgroundColor: "#00303F" }}>
              <TableRow id="yearsOfRetirement">
                <TableCell style={{ color: "white", width: "200%" }}>
                  10 Year Estimate
                </TableCell>
                {years.map((year, i) => {
                  return (
                    <TableCell key={i} style={{ color: "white" }}>
                      {year}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow id="agesOfRetirementS1">
                <TableCell>
                  <span className="userInputLabel">Age</span>
                </TableCell>
                {ageArray.map((year, i) => {
                  return <TableCell key={i}>{year}</TableCell>;
                })}
              </TableRow>

              {props.redux.both === true ? (
                <React.Fragment>
                  <TableRow id="agesOfRetirementS2">
                    <TableCell>
                      <span className="userInputLabel">Age 2</span>
                    </TableCell>
                    {marriedAgeArray.map((year, i) => {
                      return <TableCell key={i}>{year}</TableCell>;
                    })}
                  </TableRow>
                </React.Fragment>
              ) : null}

              <TableRow id="s1wages">
                <TableCell>
                  <span className="userInputLabel">Salary</span>
                </TableCell>
                {wageArray.map((wage, i) => (
                  <TableCell key={i}>${wage}</TableCell>
                ))}
              </TableRow>

              {props.redux.both === true ? (
                <React.Fragment>
                  <TableRow id="s2wages">
                    <TableCell>
                      <span className="userInputLabel">Salary 2</span>
                    </TableCell>
                    {marriedWageArray.map((year, i) => {
                      return <TableCell key={i}>${year}</TableCell>;
                    })}
                  </TableRow>
                </React.Fragment>
              ) : null}

              <TableRow id="s1socialSecurity">
                <TableCell>
                  <span className="userInputLabel">Social Security</span>
                </TableCell>
                {ssArray.map((ss, i) => (
                  <TableCell key={i}>${ss}</TableCell>
                ))}
              </TableRow>

              {props.redux.both === true ? (
                <React.Fragment>
                  <TableRow id="s2socialSecurity">
                    <TableCell>
                      <span className="userInputLabel">Social Security 2</span>
                    </TableCell>
                    {marriedSsArray.map((year, i) => {
                      return <TableCell key={i}>${year}</TableCell>;
                    })}
                  </TableRow>
                </React.Fragment>
              ) : null}

              <TableRow id="s1pvtPension">
                <TableCell>
                  <span className="userInputLabel">Private Pension</span>
                </TableCell>
                {pvtArray.map((pvt, i) => (
                  <TableCell key={i}>${pvt}</TableCell>
                ))}
              </TableRow>

              {props.redux.both === true ? (
                <React.Fragment>
                  <TableRow id="s2pvtPension">
                    <TableCell>
                      <span className="userInputLabel">Private Pension 2</span>
                    </TableCell>
                    {marriedPvtArray.map((year, i) => {
                      return <TableCell key={i}>${year}</TableCell>;
                    })}
                  </TableRow>
                </React.Fragment>
              ) : null}

              <TableRow id="s1pubPension">
                <TableCell>
                  <span className="userInputLabel">Public Pension</span>
                </TableCell>
                {pubArray.map((pub, i) => (
                  <TableCell key={i}>${pub}</TableCell>
                ))}
              </TableRow>

              {props.redux.both === true ? (
                <React.Fragment>
                  <TableRow id="s2pubPension">
                    <TableCell>
                      <span className="userInputLabel">Public Pension 2</span>
                    </TableCell>
                    {marriedPubArray.map((year, i) => {
                      return <TableCell key={i}>${year}</TableCell>;
                    })}
                  </TableRow>
                </React.Fragment>
              ) : null}

              <TableRow id="s1houseIra401draw">
                <TableCell>
                  <span className="userInputLabel">
                    Potential Investment Draw
                  </span>
                </TableCell>
                {investmentIncomeArray.map((income, i) => {
                  return <TableCell key={i}>${income}</TableCell>;
                })}
              </TableRow>

              {props.redux.both === true ? (
                <React.Fragment>
                  <TableRow id="s2houseIra401draw">
                    <TableCell>
                      <span className="userInputLabel">
                        Potential Investment Draw 2
                      </span>
                    </TableCell>
                    {marriedInvestmentIncomeArray.map((year, i) => {
                      return <TableCell key={i}>${year}</TableCell>;
                    })}
                  </TableRow>
                </React.Fragment>
              ) : null}

              <TableRow id="houseTargetBudget">
                <TableCell>
                  <span className="userInputLabel">Target Budget</span>
                </TableCell>
                {budgetArray.map((budget, i) => {
                  return (
                    <TableCell key={i}>{"$" + parseInt(budget || 0)}</TableCell>
                  );
                })}
              </TableRow>

              <TableRow id="nonIra401Income">
                <TableCell>
                  <span className="userInputLabel">Non-Investment Income</span>
                </TableCell>
                {non401IRAArray.map((income, i) => {
                  return <TableCell key={i}>${income}</TableCell>;
                })}
              </TableRow>

              <TableRow id="incomeWithFullIra401">
                <TableCell>
                  <span className="userInputLabel">
                    Income w/full Investment Draw
                  </span>
                </TableCell>
                {totalIncomeArray.map((income, i) => {
                  return <TableCell key={i}>${income}</TableCell>;
                })}
              </TableRow>

              {!props.redux.both ? (
                <TableRow id="needMoney">
                  <TableCell></TableCell>
                  {incomeNeededArray.map((income, i) => {
                    let need;
                    if (parseInt(income, 10) > 0) {
                      need = <p style={{ color: "#d14545" }}>Need $</p>;
                    } else if (parseInt(income, 10) < 0) {
                      need = <p style={{ color: "#54a589" }}>Excess $</p>;
                    } else if (incomeNeededArray[i] === 0) {
                      need = <p style={{ color: "#54a589" }}>Balanced</p>;
                    }
                    return <TableCell key={i}>{need}</TableCell>;
                  })}
                </TableRow>
              ) : (
                <TableRow id="needMoney">
                  <TableCell></TableCell>
                  {marriedIncomeNeededArray.map((income, i) => {
                    let need;
                    if (parseInt(income, 10) > 0) {
                      need = <p style={{ color: "#d14545" }}>Need $</p>;
                    } else if (parseInt(income, 10) < 0) {
                      need = <p style={{ color: "#54a589" }}>Excess $</p>;
                    } else if (incomeNeededArray[i] === 0) {
                      need = <p style={{ color: "#54a589" }}>Balanced</p>;
                    }
                    return <TableCell key={i}>{need}</TableCell>;
                  })}
                </TableRow>
              )}

              {!props.redux.both ? (
                <TableRow id="s1houseIra401draw">
                  <TableCell>
                    <span className="userInputLabel">
                      Reduce Investment Draw
                    </span>
                  </TableCell>
                  {annuityIncomeArray.map((income, i) => {
                    let amount;
                    if (
                      parseInt(income, 10) <= 0 &&
                      investmentIncomeArray[i] > 0
                    ) {
                      if (investmentIncomeArray[i] < income) {
                        amount = investmentIncomeArray[i];
                      } else {
                        amount = Math.abs(
                          parseInt(investmentIncomeArray[i]) +
                            parseInt(income, 10)
                        );
                      }
                    } else {
                      amount = 0;
                    }
                    return <TableCell key={i}>${income}</TableCell>;
                  })}
                </TableRow>
              ) : (
                <TableRow id="s1houseIra401draw">
                  <TableCell>
                    <span className="userInputLabel">
                      Reduce Investment Draw
                    </span>
                  </TableCell>
                  {marriedAnnuityIncomeArray.map((income, i) => {
                    let amount;
                    if (
                      parseInt(income, 10) <= 0 &&
                      marriedInvestmentIncomeArray[i] > 0
                    ) {
                      if (investmentIncomeArray[i] < income) {
                        amount = marriedInvestmentIncomeArray[i];
                      } else {
                        amount = Math.abs(
                          parseInt(marriedInvestmentIncomeArray[i]) +
                            parseInt(income, 10)
                        );
                      }
                    } else {
                      amount = 0;
                    }
                    return <TableCell key={i}>${income}</TableCell>;
                  })}
                </TableRow>
              )}

              {!props.redux.both ? (
                <TableRow id="addlIncomeReq">
                  <TableCell>
                    <span className="userInputLabel">
                      Additional Income Required
                    </span>
                  </TableCell>
                  {incomeNeededArray.map((income, i) => {
                    let tempIncome;
                    if (parseInt(income) <= 0) {
                      tempIncome = 0;
                    } else {
                      tempIncome = income;
                    }
                    return <TableCell key={i}>${tempIncome}</TableCell>;
                  })}
                </TableRow>
              ) : (
                <TableRow id="addlIncomeReq">
                  <TableCell>
                    <span className="userInputLabel">
                      Additional Income Required
                    </span>
                  </TableCell>
                  {marriedIncomeNeededArray.map((income, i) => {
                    let tempIncome;
                    if (parseInt(income) <= 0) {
                      tempIncome = 0;
                    } else {
                      tempIncome = income;
                    }
                    return <TableCell key={i}>${tempIncome}</TableCell>;
                  })}
                </TableRow>
              )}

              {!props.redux.both ? (
                <TableRow id="addlIncomeReq">
                  <TableCell>
                    <span className="userInputLabel">
                      Reported Household IRA/401K
                    </span>
                  </TableCell>
                  {actualInvestmentArray.map((income, i) => {
                    let tempIncome;
                    if (parseInt(income) <= 0) {
                      tempIncome = 0;
                    } else {
                      tempIncome = income;
                    }
                    return <TableCell key={i}>${tempIncome}</TableCell>;
                  })}
                </TableRow>
              ) : (
                <TableRow id="addlIncomeReq">
                  <TableCell>
                    <span className="userInputLabel">
                      Reported Household IRA/401K
                    </span>
                  </TableCell>
                  {marriedActualInvestmentArray.map((income, i) => {
                    let tempIncome;
                    if (parseInt(income) <= 0) {
                      tempIncome = 0;
                    } else {
                      tempIncome = income;
                    }
                    return <TableCell key={i}>${tempIncome}</TableCell>;
                  })}
                </TableRow>
              )}

              {/* Age Group Calculations Test */}
              {/* <TableRow id="ageGroupS1">
                <TableCell>
                  <span className="userInputLabel">Age Group S1</span>
                </TableCell>
                {ageGroupArrayS1.map((age, i) => {
                  return (
                    <TableCell key={i} style={{ color: "red" }}>
                      {age}
                    </TableCell>
                  );
                })}
              </TableRow>

              {props.redux.both === true ? (
                <React.Fragment>
                  <TableRow id="ageGroupS2">
                    <TableCell>
                      <span className="userInputLabel">Age Group S2</span>
                    </TableCell>
                    {ageGroupArrayS2.map((year, i) => {
                      return <TableCell key={i}>{year}</TableCell>;
                    })}
                  </TableRow>
                </React.Fragment>
              ) : null} */}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Dialog
        style={{
          margin: "auto",
        }}
        open={showTriviaModal}
        TransitionComponent={Transition}
        disableBackdropClick={false}
        hideBackdrop={false}
        onClose={() => setTriviaModal(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <Trivia handleClose={() => setTriviaModal(false)} />
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    redux: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateForm: (formData) => updateForm(formData),
      testCalculatorData: () => testCalculatorData(),
      testUserData: () => testUserData(),
      setBirthday1: (params) => setBirthday1(params),
      setBirthday2: (params) => setBirthday2(params),
      setAge1: () => setAge1(),
      setAge2: () => setAge2(),
      setTotalIncome: () => setTotalIncome(),
      setMarriedIncome: () => setMarriedIncome(),
      setNon401IraIncome: () => setNon401IraIncome(),
      generateBudget: () => generateBudget(),
      generateWages: () => generateWages(),
      generateSS: () => generateSS(),
      generatePrivatePension: () => generatePrivatePension(),
      generatePublicPension: () => generatePublicPension(),
      setInvestmentIncome: () => setInvestmentIncome(),
      generateShortfall: () => generateShortfall(),
      generateYears: (years) => generateYears(years),
      calculateNeeded: () => calculateNeeded(),
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Calculator);
